module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticStyle: {
      "width": "600px",
      "margin": "auto"
    },
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "90px",
      "element-loading-text": _vm.elementLoadingText
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("退货商品：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.productImage
    }
  })])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_vm._v("           \n            " + _vm._s(_vm.productName) + "    \n            "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "color": "#FF5E00 !important"
    }
  }, [_vm._v("￥" + _vm._s(Number(_vm.productPrice).toFixed(2)))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "el-form-item is-required"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("退货数量：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.num),
      expression: "form.num"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "number",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.num)
    },
    on: {
      "change": _vm.changeNum,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "num", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("已退数量：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.alreadyReturnNum) + "\n              ")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("退货中：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.alreadyReturnNum) + "\n              ")])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "el-form-item is-required"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("退款金额：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.refundAmount),
      expression: "form.refundAmount"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "number",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.refundAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "refundAmount", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "el-form-item is-required"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("售后类型：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.needReturn),
      expression: "form.needReturn"
    }],
    staticClass: "refundReason",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "needReturn", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("我要退款(无需退货)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("我要退货退款")])])])])])])], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "el-form-item is-required"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("退货原因：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.reason),
      expression: "form.reason"
    }],
    staticClass: "refundReason",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "reason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.refundReasons), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.reason
      }
    }, [_vm._v(_vm._s(item.reason))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("退货说明：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "refundDescription",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "closeBtn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "saveBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.validateData
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d9053cf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/components/OrderReturn.vue
// module id = 751
// module chunks = 2